export default __webpack_public_path__ + "static/media/emoji-messagerie.20e00318.svg";